import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import {
    checkStatus,
    dbFormatDate,
    formatToStandardDate,
    standardFormatToday,
} from "./utils";
import { checkUserDetailsFromCookie, fetchBrands } from "./userManagement";
import { createCookie, deleteCookie, sendApiRequest, sendApiRequestWithFile, setBatchLoadingStatus } from "./requestConfig";
import { LISTING_RELOAD, withListingReload } from "./listingReload";
import { rootRetailerOptionFields } from "../components/commonComponents/Filters/storeFilterUtils";
import { ownerCompanyIdForSave, ownerRequiredOnCreate } from "./crossCompanyAccess";
import {
    clearStagedOwnerOutsideRetailerNotice,
    showStagedOwnerOutsideRetailerNotice,
    stageOwnerOutsideRetailerNotice,
} from "../components/commonComponents/Hoc/accessControlToasts";

// validate general info while adding/updating a loop campaign
export const validateLoopCampaignGeneralInfo = (validateFor) => {
    const currentStateData = store.getState().userSelections;
    let error = false;
    let errorMessages = {};
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
        userDetailObj = checkUserDetails.user_detail;
    }

    // loop name
    const loopName =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.loop_name !== "undefined"
            ? currentStateData.new_loop_data.loop_name
            : "";
    // loop owner id
    const loopOwnerId =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.loop_owner_id !== "undefined"
            ? currentStateData.new_loop_data.loop_owner_id
            : "";
    // brand name
    const brandName =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.brand_name !== "undefined"
            ? currentStateData.new_loop_data.brand_name
            : "";

    // brand company id
    const brandCompanyId =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.loop_brand_company_id !== "undefined"
            ? currentStateData.new_loop_data.loop_brand_company_id
            : "";

    const manualBrandCompany =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.manual_brand_company !== "undefined"
            ? currentStateData.new_loop_data.manual_brand_company
            : false;

    const manualBrandCompanyName =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.loop_brand_company_name !== "undefined"
            ? currentStateData.new_loop_data.loop_brand_company_name
            : "";
    // start date
    const loopStartDate =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.loop_start_date !== "undefined"
            ? currentStateData.new_loop_data.loop_start_date
            : "";
    // end date
    const loopEndDate =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.loop_end_date !== "undefined"
            ? currentStateData.new_loop_data.loop_end_date
            : "";

    // loop_prioritization: disabled for pre_prod deploy — inStore not ready
    const loopCampaignType =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.loop_campaign_type_id !== "undefined"
            ? currentStateData.new_loop_data.loop_campaign_type_id
            : "";

    // check loop name
    if (loopName === "") {
        error = true;
        errorMessages = {
            ...errorMessages,
            loop_name: "Please enter the campaign name",
        };
    }

    // check brandName
    if (brandName === "") {
        error = true;
        errorMessages = {
            ...errorMessages,
            brand_name: "Please enter the brand name",
        };
    }

    // brand company
    if (brandCompanyId === "" && manualBrandCompany === false) {
        error = true;
        errorMessages = {
            ...errorMessages,
            brand_company: "Please select the brand company",
        };
    }

    if (manualBrandCompanyName === "" && manualBrandCompany === true) {
        error = true;
        errorMessages = {
            ...errorMessages,
            loop_brand_company_name: "Please enter the brand company name",
        };
    }

    if (manualBrandCompanyName !== "" && manualBrandCompany === true) {
        // check if the name already exist
        if (
            typeof currentStateData.brand_names_arr !== "undefined" &&
            currentStateData.brand_names_arr.includes(manualBrandCompanyName)
        ) {
            error = true;
            errorMessages = {
                ...errorMessages,
                loop_brand_company_name: "Brand company name already exists",
            };
        }
    }

    // check start date
    if (loopStartDate === "") {
        error = true;
        errorMessages = {
            ...errorMessages,
            loop_start_date: "Please select the start date for the loop campaign",
        };
    }
    // check end date
    if (loopEndDate === "") {
        error = true;
        errorMessages = {
            ...errorMessages,
            loop_end_date: "Please select the end date for the loop campaign",
        };
    }
    // validate that start should not be after end date and vice versa
    if (loopStartDate !== "" && loopEndDate !== "") {
        const formattedStartDate = loopStartDate; // dateInCorrectTimezone();
        const formattedEndDate = loopEndDate; // dateInCorrectTimezone(picEndDate);
        //start/end should not be after end date
        if (formattedEndDate < formattedStartDate) {
            error = true;
            errorMessages = {
                ...errorMessages,
                loop_end_date: "End date must be after the start date",
            };
        }
    }


    // retailer company
    if (ownerRequiredOnCreate(userDetailObj.user_type, validateFor, loopOwnerId) === true) {
        error = true;
        errorMessages = {
            ...errorMessages,
            loop_owner: "Please select the owner",
        };
    }

    // campaign type
    if (loopCampaignType === "") {
        error = true;
        errorMessages = {
            ...errorMessages,
            loop_campaign_type: "Please select the campaign type",
        };
    }

    // show error message (if error === true)
    if (error === true) {
        toast("Please fill in valid information", { type: "error" });
        return {
            error: true,
            errorMessages,
        };
    } else {
        // fetch visual upload limit and duration based on the loop owner id.
        // fetchVisualLimit(loopOwnerId, loopCampaignType);
        return {
            error: false,
            errorMessages: {},
        };
    }
};

// validate file selection
export const validateVisuals = (acceptedFiles, usedFor) => {
    const currentStateData = store.getState().userSelections;
    let error = false;
    let errorMessages = {};
    // atleast one acceptable file must be selected
    if (usedFor !== "update") {
        if (acceptedFiles.length === 0) {
            error = true;
            errorMessages = {
                ...errorMessages,
                file_error: "Please upload a supported file",
            };
        }
    } else {
        // atleast one visual must be active or a new file must be uploaded, if used for update
        if (typeof currentStateData.loop_campaign_visuals === "undefined" || currentStateData.loop_campaign_visuals.filter(visual => visual.active === true).length === 0) {
            if (acceptedFiles.length === 0) {
                error = true;
                errorMessages = {
                    ...errorMessages,
                    file_error: "Atleast one visual must be active, Please upload a supported file",
                };
            }
        }
    }

    // show error message (if error === true)
    if (error === true) {
        toast(errorMessages.file_error, { type: "error" });
        return {
            error: true,
            errorMessages,
        };
    } else {
        return {
            error: false,
            errorMessages: {},
        };
    }
};

// validate stores selection
export const validateStoreSelection = () => {
    const currentStateData = store.getState().userSelections;
    let error = false;
    let errorMessages = {};

    // loop name
    const selectedStores =
        typeof currentStateData.new_loop_data !== "undefined" &&
            typeof currentStateData.new_loop_data.selected_stores !== "undefined"
            ? currentStateData.new_loop_data.selected_stores
            : [];

    // check end date
    if (selectedStores.length === 0) {
        error = true;
        errorMessages = {
            ...errorMessages,
            selected_store: "Please select the stores..",
        };
    }

    // show error message (if error === true)
    if (error === true) {
        toast("Please select the stores", { type: "error" });
        return {
            error: true,
            errorMessages,
        };
    } else {
        return {
            error: false,
            errorMessages: {},
        };
    }
};

// test multiple file upload, plus general info data.
export const testMultiUploadWithData = async (acceptedFiles) => {
    const currentStateData = store.getState().userSelections;
    const formData = new FormData();
    acceptedFiles.forEach((fileDetail) => {
        formData.append("files", fileDetail);
    });
    const dataString = new Blob([JSON.stringify({ id: 653, content: "testere" })], {
        type: "application/json",
    });
    formData.append("data", dataString);

    await sendApiRequestWithFile(
        "test-multi-save",
        formData,
        "POST"
    );
    return {
        error: false
    }
}

// save/update loop pagination info in cookies
export const manageLoopsPaginationCookie = (loopPaginationObj) => {
    const currentStateData = store.getState().userSelections;
    //
    const paginationObj = typeof currentStateData.loops_pagination !== "undefined" ? currentStateData.loops_pagination : {};

    store.dispatch(updateStateData({ loops_pagination: { ...paginationObj, ...loopPaginationObj } }));

    deleteCookie("loops_pagination");
    // set cookie for pagination
    createCookie("loops_pagination", JSON.stringify({ ...paginationObj, ...loopPaginationObj }));
}

// list loop campaigns
export const listLoopCampaigns = async (pageNumber, pageSize, reloadOptions = {}) => {
    return withListingReload(LISTING_RELOAD.loops, () => listLoopCampaignsPage(pageNumber, pageSize), reloadOptions);
};

const listLoopCampaignsPage = async (pageNumber, pageSize) => {
    const currentStateData = store.getState().userSelections;
    // check if page number and page size are passed from the component, if not then set default values.
    if (typeof pageNumber === "undefined" && typeof pageSize === "undefined") {
        pageNumber = 0;
        pageSize = 10;
        // page number/size from the cookies if available
        if (typeof currentStateData.loops_pagination !== "undefined") {
            pageNumber = currentStateData.loops_pagination.pageNumber;
            pageSize = currentStateData.loops_pagination.pageSize;
        }
    }
    let loopsListApiEndpoint = "campaigns/loop-based?page=" + pageNumber + "&size=" + pageSize;

    // check if filters are applied, then we need to fetch the filtered list.
    if (
        typeof currentStateData.loop_list_filters !== "undefined" && currentStateData.loop_list_filter_applied === true
    ) {
        // loop name filter
        if (
            typeof currentStateData.loop_list_filters.loop_name !== "undefined" &&
            currentStateData.loop_list_filters.loop_name.length !== 0
        ) {
            // duplicate loop campaign names collapse to one dropdown option, so loop_name_ids
            // holds every id sharing a chosen name; fall back to loop_name for filters saved before it existed
            const loopNameIds =
                Array.isArray(currentStateData.loop_list_filters.loop_name_ids) &&
                currentStateData.loop_list_filters.loop_name_ids.length !== 0
                    ? currentStateData.loop_list_filters.loop_name_ids
                    : currentStateData.loop_list_filters.loop_name;
            loopNameIds.forEach((item) => {
                loopsListApiEndpoint = loopsListApiEndpoint + "&id_campaign=" + item;
            });
        }
        // visual name filter  
        if (
            typeof currentStateData.loop_list_filters.visual_name !== "undefined" &&
            currentStateData.loop_list_filters.visual_name.length !== 0
        ) {
            currentStateData.loop_list_filters.visual_name.forEach((item) => {
                loopsListApiEndpoint = loopsListApiEndpoint + "&visual=" + item;
            });
        }
        // retailer/owner filter
        if (
            typeof currentStateData.loop_list_filters.loop_company_filter !== "undefined" &&
            currentStateData.loop_list_filters.loop_company_filter.length !== 0
        ) {
            currentStateData.loop_list_filters.loop_company_filter.forEach((item) => {
                loopsListApiEndpoint = loopsListApiEndpoint + "&id_company=" + item;
            });
        }
        // Root retailer filter (UI label "Retailer"; Redux key root_retailer_filter)
        if (
            typeof currentStateData.loop_list_filters.root_retailer_filter !== "undefined" &&
            currentStateData.loop_list_filters.root_retailer_filter.length !== 0
        ) {
            currentStateData.loop_list_filters.root_retailer_filter.forEach((item) => {
                loopsListApiEndpoint = loopsListApiEndpoint + "&retailer=" + item;
            });
        }
        // progress filter
        if (
            typeof currentStateData.loop_list_filters.status_filter !== "undefined" &&
            currentStateData.loop_list_filters.status_filter.length !== 0
        ) {
            currentStateData.loop_list_filters.status_filter.forEach((item) => {
                loopsListApiEndpoint = loopsListApiEndpoint + "&progress=" + item;
            });
        }
        // store filter
        if (
            typeof currentStateData.loop_list_filters.loop_number_store_cyreen !== "undefined" &&
            currentStateData.loop_list_filters.loop_number_store_cyreen.length !== 0
        ) {
            currentStateData.loop_list_filters.loop_number_store_cyreen.forEach((item) => {
                loopsListApiEndpoint = loopsListApiEndpoint + "&id_store=" + item;
            });
        }

        // campaign type filter campaign_type
        if (
            typeof currentStateData.loop_list_filters.campaign_type !== "undefined" &&
            currentStateData.loop_list_filters.campaign_type !== null
        ) {
            loopsListApiEndpoint = loopsListApiEndpoint + "&type=" + currentStateData.loop_list_filters.campaign_type;
        }
    }

    const checkLoops = await sendApiRequest(loopsListApiEndpoint, "", "GET");

    let response = {};
    if (checkLoops.success === true) {
        let loopsList = [];
        let loopNamesList = [];
        let loopStoresList = [];
        let alreadyUsedStores = [];

        let loopCompanyNamesList = [];

        /*need to restructure loops response as there's a lot of extra info returned in the response.*/
        if (checkLoops.response.content.length !== 0) {
            //   loop through the loops response
            checkLoops.response.content.forEach((loop) => {
                //decide campaign status by comparing current date with start and end date of campaign.
                const currentDate = standardFormatToday();
                const picStartDate = formatToStandardDate(loop.date_start);
                const picEndDate = formatToStandardDate(loop.date_end);
                const loopProgressStatus = checkStatus(loop.date_start, loop.date_end);

                loopsList.push({
                    id: loop.id,
                    name: loop.name,
                    retailer: typeof loop.retailer !== "undefined" ? loop.retailer.name : "",
                    id_advertiser: loop.advertiser,
                    stores: loop.count_stores,
                    start_date: loop.date_start,
                    end_date: loop.date_end,
                    last_edit_by: loop.last_edit,
                    status: loopProgressStatus,
                    loop_company_name: loop.company.name,
                    loop_company_id: loop.company.id,
                    root_retailer_company: loop.root_retailer_company,
                    // Retailer column shows every retailer of the loop campaign (plain names, no objects)
                    retailer_names: Array.isArray(loop.retailer_names) ? loop.retailer_names : [],
                    active: loop.active,
                    num_visuals_active: loop.num_visuals_active,
                    company: loop.company,
                    advertiser: loop.advertiser,
                    store_list: loop.stores,
                    brand_name: loop?.brand_name,
                    visuals: loop.visuals,
                    // loop_prioritization: disabled for pre_prod deploy — inStore not ready
                    loop_campaign_type_id: loop?.type,
                    selected_store_options: loop.stores.map((storeInfo) => {
                        return {
                            label: storeInfo.name,
                            id: storeInfo.id,
                            retailer_id: storeInfo.retailer_id,
                            ...rootRetailerOptionFields(storeInfo),
                        };
                    }),
                    share_list: loop.share_list,
                });
                loopNamesList.push({ id: loop.id, label: loop.content });
                loopCompanyNamesList.push({ id: loop.company.id, label: loop.company.name });
                loopStoresList = [
                    ...loopStoresList,
                    ...loop.stores
                        .map((storeInfo) => {
                            if (alreadyUsedStores.includes(storeInfo.name)) {
                                return false;
                            } else {
                                alreadyUsedStores.push(storeInfo.name);
                                return { label: storeInfo.name, id: storeInfo.id, retailer_id: storeInfo.retailer_id };
                            }
                        })
                        .filter((store) => {
                            return store !== false;
                        }),
                ];
            });
        }


        // save to the redux state
        store.dispatch(
            updateStateData({
                loop_campaign_list: loopsList,
                loop_names_list: loopNamesList,
                loop_company_name_list: loopCompanyNamesList,
                loop_stores_filter_list: loopStoresList,
            })
        );

        // save/update campaign pagination info
        manageLoopsPaginationCookie({
            totalPages: checkLoops.response.totalPages,
            totalRecords: checkLoops.response.totalElements,
            pageNumber: checkLoops.response.number,
            pageSize: checkLoops.response.size,
        })

        // scroll to the top of page
        window.scrollTo(0, 0);

        response = {
            success: true,
        };
    } else {
        response = {
            success: false,
        };
    }
    return response;
};

// save/update loop pagination info in cookies
export const manageStoreCapacityPaginationCookie = (capacityPaginationObj) => {
    const currentStateData = store.getState().userSelections;
    //
    const paginationObj = typeof currentStateData.store_capacity_pagination !== "undefined" ? currentStateData.store_capacity_pagination : {};

    store.dispatch(updateStateData({
        store_capacity_pagination: {
            ...paginationObj,
            ...capacityPaginationObj
        }
    }));

    deleteCookie("store_capacity_pagination");
    // set cookie for pagination
    createCookie("store_capacity_pagination", JSON.stringify({ ...paginationObj, ...capacityPaginationObj }));
}

// to select all stores if "Select All" is enabled while adding new loop campaign.
export const selectAllStores = async (loopId) => {
    const storeDetails = store.getState().userSelections;
    const selectedLoopData = typeof storeDetails.new_loop_data !== "undefined" ? storeDetails.new_loop_data : {};

    // load store list
    const storeCapacityList = await listStoreCapacities(loopId, 0, 5000, "download", true);
    // storesList : contains newly loaded stores
    const storesList = typeof storeCapacityList.store_capacity_list !== "undefined" ? storeCapacityList.store_capacity_list : [];
    // preselectedstores: this variable has values which are already selected
    const preSelectedStores = typeof storeDetails.new_loop_data !== "undefined" && typeof storeDetails.new_loop_data.selected_stores !== "undefined" ? storeDetails.new_loop_data.selected_stores : [];
    // filter the new store list to exclude values which are already selected.
    const selectedStores = storesList.filter(newStore => {
        return !preSelectedStores.some(preSelected => preSelected.number_store_cyreen === newStore.number_store_cyreen)
    }).filter(newStore => {
        return newStore.available === true
    }).map(store => {
        return { number_store_cyreen: store.number_store_cyreen, tree_path: store.company.tree_path }
    });
    store.dispatch(
        updateStateData({
            new_loop_data: {
                ...selectedLoopData,
                all_stores_selected: true,
                selected_stores: [...preSelectedStores, ...selectedStores]
            },
        })
    );
}

// to fetch list of store capacity filters
export const fetchCapacityStoreNameFilterOptions = async () => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);

    let apiEndpoint = "campaigns/loop-based/store-capacities/filter/name";
    if (ownerId !== "") {
        apiEndpoint += "?id_company_owner=" + ownerId;
    }

    // api endpoint to fetch store names
    const storesList = await sendApiRequest(apiEndpoint, {}, "GET", { skipRetailerViewFilter: true });
    if (typeof storesList.success !== "undefined" && storesList.success === true) {
        let storeNamesList = [];
        let storeNameFullObj = [];
        storesList.response.value.forEach((name) => {
            storeNamesList.push({ value: name, label: name });
        });

        store.dispatch(
            updateStateData({
                capacity_store_names_list: storeNamesList,
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
}

// fetch store capacities address, zip code, region and owner filter options
export const fetchCapacityAddressFilterOptions = async () => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);

    let apiEndpoint = "campaigns/loop-based/store-capacities/filter/address";
    if (ownerId !== "") {
        apiEndpoint += "?id_company_owner=" + ownerId;
    }
    // api endpoint to fetch store names
    const AddressList = await sendApiRequest(apiEndpoint, {}, "GET", { skipRetailerViewFilter: true });
    if (typeof AddressList.success !== "undefined" && AddressList.success === true) {
        let addressNamesList = [];
        AddressList.response.value.forEach((addr) => {
            addressNamesList.push({ value: addr, label: addr });
        });

        store.dispatch(
            updateStateData({
                capacity_address_names_list: addressNamesList,
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
}

export const fetchCapacityZipCodeFilterOptions = async () => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);

    let apiEndpoint = "campaigns/loop-based/store-capacities/filter/zip-code";
    if (ownerId !== "") {
        apiEndpoint += "?id_company_owner=" + ownerId;
    }
    // api endpoint to fetch store names
    const zipCodeList = await sendApiRequest(apiEndpoint, {}, "GET", { skipRetailerViewFilter: true });
    if (typeof zipCodeList.success !== "undefined" && zipCodeList.success === true) {
        let zipCodeResultList = [];
        zipCodeList.response.value.forEach((zip) => {
            zipCodeResultList.push({ value: zip, label: zip });
        });

        store.dispatch(
            updateStateData({
                capacity_zip_code_list: zipCodeResultList,
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
}

export const fetchCapacityCityFilterOptions = async () => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);

    let apiEndpoint = "campaigns/loop-based/store-capacities/filter/city";
    if (ownerId !== "") {
        apiEndpoint += "?id_company_owner=" + ownerId;
    }
    // api endpoint to fetch store names
    const cityList = await sendApiRequest(apiEndpoint, {}, "GET", { skipRetailerViewFilter: true });
    if (typeof cityList.success !== "undefined" && cityList.success === true) {
        let cityNamesList = [];
        cityList.response.value.forEach((city) => {
            cityNamesList.push({ value: city, label: city });
        });

        store.dispatch(
            updateStateData({
                capacity_city_names_list: cityNamesList,
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }

}

export const fetchCapacityRegionFilterOptions = async () => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);

    let apiEndpoint = "campaigns/loop-based/store-capacities/filter/region";
    if (ownerId !== "") {
        apiEndpoint += "?id_company_owner=" + ownerId;
    }
    // api endpoint to fetch store names
    const regionList = await sendApiRequest(apiEndpoint, {}, "GET", { skipRetailerViewFilter: true });
    if (typeof regionList.success !== "undefined" && regionList.success === true) {
        let regionNamesList = [];
        regionList.response.value.forEach((region) => {
            regionNamesList.push({ value: region, label: region });
        });

        store.dispatch(
            updateStateData({
                capacity_region_names_list: regionNamesList,
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }

}

export const fetchCapacityOwnerFilterOptions = async () => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);

    let apiEndpoint = "companies/list-stores";
    if (ownerId !== "") {
        apiEndpoint += "?id_company_owner=" + ownerId;
    }
    // api endpoint to fetch store names
    const ownerList = await sendApiRequest(apiEndpoint, {}, "GET", { skipRetailerViewFilter: true });
    if (typeof ownerList.success !== "undefined" && ownerList.success === true) {
        let ownerNamesList = [];
        ownerList.response.forEach((owner) => {
            ownerNamesList.push({ id: owner.id, label: owner.name, tree_path: owner.tree_path });
        });

        store.dispatch(
            updateStateData({
                capacity_owner_names_list: ownerNamesList,
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
}

// Retailer options for the loop store-capacity step only.
// Listing filters still use companies/retailer-roots.
export const fetchCapacityRetailerFilterOptions = async () => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);

    let apiEndpoint = "dropdowns/filters/store-capacities/retailers";
    if (ownerId !== "") {
        apiEndpoint += "?id_company_owner=" + ownerId;
    }

    const retailerList = await sendApiRequest(apiEndpoint, {}, "GET", { skipRetailerViewFilter: true });
    if (typeof retailerList.success === "undefined" || retailerList.success !== true) {
        return {
            success: false,
            options: [],
        };
    }

    const rows = Array.isArray(retailerList.response)
        ? retailerList.response
        : Array.isArray(retailerList.response?.value)
            ? retailerList.response.value
            : [];

    return {
        success: true,
        options: rows.map((retailer) => ({
            id: retailer.id,
            label: retailer.name,
        })),
    };
}

// fetch store capacities list from backend.
export const listStoreCapacities = async (id_loop_campaign = "", pageNumber, pageSize, usedFor = "list", applyFilter = true) => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);
    // loop_prioritization: disabled for pre_prod deploy — inStore not ready
    const loopCampaigntype = typeof currentStateData.new_loop_data !== "undefined" && typeof currentStateData.new_loop_data.loop_campaign_type_id !== "undefined" ? currentStateData.new_loop_data.loop_campaign_type_id : "";

    // check if page number and page size are passed from the component, if not then set default values.
    if (typeof pageNumber === "undefined" && typeof pageSize === "undefined") {
        pageNumber = 0;
        pageSize = 10;
        // page number/size from the cookies if available
        if (typeof currentStateData.store_capacity_pagination !== "undefined") {
            pageNumber = currentStateData.store_capacity_pagination.pageNumber;
            pageSize = currentStateData.store_capacity_pagination.pageSize;
        }
    }

    // loop_prioritization: reverted for pre_prod deploy — inStore not ready
    let storeCapacityApiEndpoint = "campaigns/loop-based/store-capacities?page=" + pageNumber + "&size=" + pageSize + "&id_company_owner=" + ownerId + "&date_start=" + dbFormatDate(currentStateData.new_loop_data.loop_start_date) + "&date_end=" + dbFormatDate(currentStateData.new_loop_data.loop_end_date) + "&type=" + loopCampaigntype;
    // let storeCapacityApiEndpoint = "campaigns/loop-based/store-capacities?page=" + pageNumber + "&size=" + pageSize + "&id_company_owner=" + ownerId + "&date_start=" + dbFormatDate(currentStateData.new_loop_data.loop_start_date) + "&date_end=" + dbFormatDate(currentStateData.new_loop_data.loop_end_date);

    // apply sorting if available
    if (typeof currentStateData.loop_stores_sorting_measure !== "undefined" && currentStateData.loop_stores_sorting_measure.sortField !== "" && currentStateData.loop_stores_sorting_measure.sortOrder !== "") {
        let sortField = currentStateData.loop_stores_sorting_measure.sortField;
        let sortOrder = currentStateData.loop_stores_sorting_measure.sortOrder;

        storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&sort_by=" + sortField + "&sort_dir=" + sortOrder;
    } else {
        storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&sort_by=name&sort_dir=asc";
    }

    // if loop_id is passed, then we need to fetch store capacities for that loop.
    if (id_loop_campaign !== "") {
        storeCapacityApiEndpoint += "&id_loop_campaign=" + id_loop_campaign;
    }

    if (typeof currentStateData.accepted_loop_files_length !== "undefined") {
        storeCapacityApiEndpoint += "&num_visuals=" + currentStateData.accepted_loop_files_length
    } else {
        storeCapacityApiEndpoint += "&num_visuals=0";
    }

    // add filters to the api endpoint if any filters are applied
    if (applyFilter === true && typeof currentStateData.store_capacity_filter_applied !== "undefined" && currentStateData.store_capacity_filter_applied === true) {
        //store name filter
        if (
            typeof currentStateData.store_capacity_filters !== "undefined" &&
            typeof currentStateData.store_capacity_filters.loop_store_filter !== "undefined" &&
            currentStateData.store_capacity_filters.loop_store_filter.length !== 0
        ) {
            currentStateData.store_capacity_filters.loop_store_filter.forEach((item) => {
                storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&store_name=" + item.value;
            });
        }
        // status filter
        if (
            typeof currentStateData.store_capacity_filters !== "undefined" &&
            typeof currentStateData.store_capacity_filters.status_filter !== "undefined" &&
            currentStateData.store_capacity_filters.status_filter.length !== 0
        ) {
            currentStateData.store_capacity_filters.status_filter.forEach((item) => {
                storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&available=" + item.value;
            });
        }
        // owner filter
        if (
            typeof currentStateData.store_capacity_filters !== "undefined" &&
            typeof currentStateData.store_capacity_filters.owner_filter !== "undefined" &&
            currentStateData.store_capacity_filters.owner_filter.length !== 0
        ) {
            currentStateData.store_capacity_filters.owner_filter.forEach((item) => {
                storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&id_company=" + item.id;
            });
        }
        // retailer (root retailer company) filter — parallel to owner id_company
        if (
            typeof currentStateData.store_capacity_filters !== "undefined" &&
            typeof currentStateData.store_capacity_filters.retailer_filter !== "undefined" &&
            currentStateData.store_capacity_filters.retailer_filter.length !== 0
        ) {
            currentStateData.store_capacity_filters.retailer_filter.forEach((item) => {
                storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&id_root_retailer_company=" + item.id;
            });
        }
        // adddress/region/zip filter
        if (
            typeof currentStateData.store_capacity_filters !== "undefined" &&
            typeof currentStateData.store_capacity_filters.address_filter !== "undefined" &&
            currentStateData.store_capacity_filters.address_filter.length !== 0
        ) {
            currentStateData.store_capacity_filters.address_filter.forEach((item) => {
                if (item.type === "zip") {
                    storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&zip_code=" + item.value;
                } else if (item.type === "region") {
                    storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&region=" + item.value;
                } else if (item.type === "city") {
                    // city filter
                    storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&city=" + item.value;
                } else {
                    // address filter
                    storeCapacityApiEndpoint = storeCapacityApiEndpoint + "&store_address=" + item.value;
                }
            });
        }
    }

    const fetchCapacity = await sendApiRequest(storeCapacityApiEndpoint, "", "GET");

    let response = {};
    if (fetchCapacity.success === true) {

        if (usedFor === "list") {
            // save stores list to redux
            store.dispatch(updateStateData({
                store_capacity_list: fetchCapacity.response.content
            }));
            // if select all option is enabled for new loop campaign wizard, then : 
            // if (typeof currentStateData.new_loop_data !== "undefined" && typeof currentStateData.new_loop_data.all_stores_selected !== "undefined" && currentStateData.new_loop_data.all_stores_selected === true) {
            //     selectAllStores();
            // }
            // save/update store capacity pagination info
            manageStoreCapacityPaginationCookie({
                totalPages: fetchCapacity.response.totalPages,
                totalRecords: fetchCapacity.response.totalElements,
                pageNumber: fetchCapacity.response.number,
                pageSize: fetchCapacity.response.size,
                availableStores: fetchCapacity.response.availableStores,
            })

            // scroll to the top of page
            window.scrollTo(0, 0);
            response = {
                success: true,
            };
        } else {
            // usedFor === "download"
            response = {
                success: true,
                store_capacity_list: fetchCapacity.response.content,
            };
        }

    } else {
        response = {
            success: false,
        };
    }
    return response;
};

// to save/update loop campaign
export const saveLoopCampaign = async (usedFor, campaignFiles) => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};

    const formData = new FormData();
    // add files to the form data (if any files are selected)
    if (typeof campaignFiles !== "undefined" && campaignFiles.length > 0) {
        campaignFiles.forEach((fileDetail) => {
            formData.append("files", fileDetail);
        });
    }

    // add loop data to the form data
    let loopData = {
        "name": currentStateData.new_loop_data.loop_name,
        "date_start": dbFormatDate(currentStateData.new_loop_data.loop_start_date),
        "date_end": dbFormatDate(currentStateData.new_loop_data.loop_end_date),
        "weekdays": [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ],
        // all_stores_selected: false,
        "stores": currentStateData.new_loop_data.selected_stores,
        "active": true,
        "add_new_brand": currentStateData.new_loop_data.manual_brand_company,
        "id_company_owner": ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id),
        "brand_name": currentStateData.new_loop_data.brand_name,
        // loop_prioritization: disabled for pre_prod deploy — inStore not ready
        type: currentStateData.new_loop_data.loop_campaign_type_id,
    }

    // add campaign id when used for update
    if (usedFor === "update") {
        loopData = {
            ...loopData,
            "id": currentStateData.new_loop_data.id,
        };
    }

    // add visuals info to the loop data
    if (typeof campaignFiles !== "undefined" && campaignFiles.length > 0) {
        loopData = {
            ...loopData,
            "num_visuals": campaignFiles.length,
            "visuals": campaignFiles.map(file => {
                return {
                    content: file.name,
                    new_content: true
                }
            })
        }
    }

    if (currentStateData.new_loop_data.manual_brand_company === false) {
        loopData = {
            ...loopData,
            id_advertiser: parseInt(currentStateData.new_loop_data.manual_brand_company === true ? "" : currentStateData.new_loop_data.loop_brand_company_id),
        };
    } else {
        loopData = {
            ...loopData,
            new_brand_name: currentStateData.new_loop_data.loop_brand_company_name,
        };
    }



    const dataString = new Blob([JSON.stringify(loopData)], {
        type: "application/json",
    });
    formData.append("data", dataString);

    // Recorded before the request. The loop form is cleared after a successful save.
    stageOwnerOutsideRetailerNotice(loopData.id_company_owner, usedFor !== "update");

    const apiEndpoint = usedFor === "update" ? "campaigns/loop-based/update" : "campaigns/loop-based/add";
    const saveData = await sendApiRequestWithFile(
        apiEndpoint,
        formData,
        "POST"
    );
    // validate api succeeded or not
    if (typeof saveData.response !== "undefined" && typeof saveData.response.success !== "undefined" && saveData.response.success === true) {

        const successMessage = usedFor === "update" ? "Loop-based Campaign updated successfully" : "Loop-based Campaign added successfully";

        manageLoopsPaginationCookie({ scroll_pos: 0 });
        // listLoopCampaigns(0, currentStateData.loops_pagination.pageSize);
        setBatchLoadingStatus(true)
        listLoopCampaigns(0, currentStateData.loops_pagination.pageSize, { refreshOptions: true }).then(() =>
            setBatchLoadingStatus(false)
        );
        toast(successMessage, { type: "success" });
        showStagedOwnerOutsideRetailerNotice();
        return {
            success: true,
            errorMessages: "",
        }
    } else {
        clearStagedOwnerOutsideRetailerNotice();
        toast("Something went wrong with store selection", { type: "error" });
        return {
            success: false,
            errorMessages: "Sorry, Something went wrong",
        }
    }
}

// to update loop campaign
export const updateLoopCampaign = async (usedFor, campaignFiles) => {
    const currentStateData = store.getState().userSelections;
    const formData = new FormData();
    if (typeof campaignFiles !== "undefined" && campaignFiles.length > 0) {
        campaignFiles.forEach((fileDetail) => {
            formData.append("files", fileDetail);
        });
    }

    let loopData = {
        "name": currentStateData.new_loop_data.loop_name,
        "date_start": dbFormatDate(currentStateData.new_loop_data.loop_start_date),
        "date_end": dbFormatDate(currentStateData.new_loop_data.loop_end_date),
        "weekdays": [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ],
        all_stores_selected: typeof currentStateData.new_loop_data.all_stores_selected !== "undefined" ?
            currentStateData.new_loop_data.all_stores_selected : false,
        "stores": currentStateData.new_loop_data.selected_stores,
        "active": true,
        "add_new_brand": currentStateData.new_loop_data.manual_brand_company,
        "id_company_owner": currentStateData.new_loop_data.loop_owner_id,
        "brand_name": currentStateData.new_loop_data.brand_name,
        "num_visuals": campaignFiles.length,
        "visuals": campaignFiles.map(file => {
            return {
                content: file.name,
                new_content: true
            }
        })
    }
    if (currentStateData.new_loop_data.manual_brand_company === false) {
        loopData = {
            ...loopData,
            id_advertiser: parseInt(currentStateData.new_loop_data.manual_brand_company === true ? "" : currentStateData.new_loop_data.loop_brand_company_id),
        };
    } else {
        loopData = {
            ...loopData,
            new_brand_name: currentStateData.new_loop_data.loop_brand_company_name,
        };
    }
    const dataString = new Blob([JSON.stringify(loopData)], {
        type: "application/json",
    });
    formData.append("data", dataString);

    // Recorded before the request. The loop form is cleared after a successful save.
    stageOwnerOutsideRetailerNotice(loopData.id_company_owner, usedFor !== "update");

    const saveData = await sendApiRequestWithFile(
        "campaigns/loop-based/add",
        formData,
        "POST"
    );
    // validate api succeeded or not
    if (typeof saveData.success !== "undefined" && saveData.success === true) {
        const successMessage = usedFor === "update" ? "Loop-based Campaign updated successfully" : "Loop-based Campaign added successfully";

        manageLoopsPaginationCookie({ scroll_pos: 0 });
        listLoopCampaigns(0, currentStateData.loops_pagination.pageSize, { refreshOptions: true });
        toast(successMessage, { type: "success" });
        showStagedOwnerOutsideRetailerNotice();
        return {
            success: true,
            errorMessages: "",
        }
    } else {
        clearStagedOwnerOutsideRetailerNotice();
        toast("Sorry, Something went wrong", { type: "error" });
        return {
            success: false,
            errorMessages: "Sorry, Something went wrong",
        }
    }
}

// reset data selected from loop wizard
export const resetLoopsData = () => {

    store.dispatch(
        deleteItems([
            "new_loop_data",
            "store_capacity_list",
            "store_capacity_pagination",
            "loop_campaign_visuals",
            "loop_store_availability",
            "accepted_loop_files_length",
            "store_capacity_filters",
            "store_capacity_filter_applied",
            "capacity_store_names_list",
            "capacity_address_names_list",
            "capacity_zip_code_list",
            "capacity_region_names_list",
            "capacity_owner_names_list",
            // loop_prioritization: disabled for pre_prod deploy — inStore not ready
            "loop_campaign_types",
            "loop_visual_limit_retailers",
            "loop_stores_sorting_measure"
        ])
    );
    deleteCookie("store_capacity_pagination", true);
};

// fetch campaign names for filters/dropdowns etc.
// silent skips the page backdrop. Listing filters pass it; the open list has its own spinner.
export const fetchLoopNames = async (requestOptions = {}) => {
    const loopList = await sendApiRequest("campaigns/loop-based/list", {}, "GET", {
        silent: requestOptions.silent === true,
    });
    if (typeof loopList.success !== "undefined" && loopList.success === true) {
        let loopNamesList = [];
        let loopNameFullObj = [];

        loopList.response.forEach((loop) => {
            loopNamesList.push({ id: loop.id, label: loop.name });
            loopNameFullObj.push(loop);
        });

        store.dispatch(
            updateStateData({
                loop_names_info: {
                    loop_names_list: loopNamesList,
                    loop_names_full_obj: loopNameFullObj,
                },
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

// fetch visual names for filters/dropdown etc.
// silent skips the page backdrop. Listing filters pass it; the open list has its own spinner.
export const fetchVisualNames = async (requestOptions = {}) => {
    const visualList = await sendApiRequest("campaigns/loop-based/visuals/list", {}, "GET", {
        silent: requestOptions.silent === true,
    });
    if (typeof visualList.success !== "undefined" && visualList.success === true) {
        let visualNamesList = [];
        let visualNameFullObj = [];

        visualList.response.forEach((visual) => {
            visualNamesList.push({ id: visual.content, label: visual.content });
            visualNameFullObj.push(visual);
        });

        store.dispatch(
            updateStateData({
                visual_names_info: {
                    visual_names_list: visualNamesList,
                    visual_names_full_obj: visualNameFullObj,
                },
            })
        );

        return {
            success: true,
        };
    } else {
        return {
            success: false,
        };
    }
};

// stop visuals in a loop campaign
export const stopLoopCampaignVisuals = async (loopId, visual_id, usedFor) => {
    const currentStateData = store.getState().userSelections;
    let requestBody = {
        id_campaign: loopId,
    };

    // check if the visual_id is empty or not
    if (typeof visual_id !== "undefined" && visual_id !== "") {
        requestBody = {
            ...requestBody,
            id_visual: [visual_id],
        };
    }

    const stopVisuals = await sendApiRequest("campaigns/loop-based/stop", requestBody, "POST");

    if (typeof stopVisuals.success !== "undefined" && stopVisuals.success === true) {
        if (typeof usedFor !== "undefined") {
            if (usedFor === "remove") {
                loadLoopCampaignVisuals(loopId);
                toast("Visual removed successfully", { type: "success" });
            }

            if (usedFor === "stop_playout") {
                loadLoopCampaignVisuals(loopId);
                toast("Visual stopped successfully", { type: "success" });
            }

            if (usedFor === "delete_campaign") {
                toast("Campaign deleted successfully", { type: "success" });
            }

            if (usedFor === "stop_campaign") {
                toast("Loop-based Campaign stopped successfully", { type: "success" });
            }

        } else {
            toast("Loop-based Campaign stopped successfully", { type: "success" });
        }

        // refresh the loop campaigns list
        listLoopCampaigns(0, currentStateData.loops_pagination.pageSize);

        return {
            success: true,
        }
    } else {
        toast("Sorry, Something went wrong", { type: "error" });
        return {
            success: false,
        }
    }
}

// load visuals for a loop campaign
export const loadLoopCampaignVisuals = async (loopId) => {
    const currentStateData = store.getState().userSelections;
    const visualsList = await sendApiRequest("campaigns/loop-based/visuals/" + loopId, {}, "GET");

    if (typeof visualsList.success !== "undefined" && visualsList.success === true) {
        // save visuals to the redux state
        store.dispatch(
            updateStateData({
                loop_campaign_visuals: visualsList.response,
                uploaded_loop_files_length: visualsList.response.filter(visual => visual.active === true).length,
            })
        );
        return {
            success: true,
        }
    } else {
        return {
            success: false,
        }
    }
}

// set loop campaign info to redux state (will be used to autofill while updating and to load info for review popup)
export const setLoopCampaignInfo = (loopInfo) => {
    const loopData = {
        id: loopInfo.id,
        loop_name: loopInfo.name,
        loop_owner_id: loopInfo.company.id,
        loop_owner: loopInfo.company.name,
        loop_start_date: formatToStandardDate(loopInfo.start_date),
        loop_end_date: formatToStandardDate(loopInfo.end_date),
        loop_start_end_status: checkStatus(loopInfo.start_date, loopInfo.end_date),
        loop_brand_company: loopInfo.advertiser.name,
        loop_brand_company_id: loopInfo.advertiser.id,
        brand_name: loopInfo?.brand_name,
        manual_brand_company: false,
        active: loopInfo.active,
        // visual_upload_limit: loopInfo.company.loop_visual_limit,
        // visual_upload_duration: loopInfo.company.loop_visual_max_duration,
        loop_campaign_type: loopInfo?.loop_campaign_type_id.charAt(0).toUpperCase() + loopInfo?.loop_campaign_type_id.slice(1).toLowerCase(),
        loop_campaign_type_id: loopInfo.loop_campaign_type_id,
        selected_stores: loopInfo.store_list.map(store => {
            return { number_store_cyreen: store.number_store_cyreen, tree_path: store.tree_path }
        })
    };
    // advertisers/Brands must be fetched based on owner id.
    fetchBrands(loopInfo.company.id);
    store.dispatch(updateStateData({
        new_loop_data: loopData,
        uploaded_loop_files_length: loopInfo.num_visuals_active
    }));
    // to fetch visual limit but it must be called after setting the "new_loop_data" in the redux state because it uses loop campaign type from the "new_loop_data" to set the visual limit.
    fetchVisualLimit(loopInfo.company.id, loopInfo?.loop_campaign_type_id);
}

// fetch store specific availability details for a loop campaign
export const fetchStoreAvailability = async (numStoreCyreen) => {
    const currentStateData = store.getState().userSelections;
    const checkUserDetails = checkUserDetailsFromCookie();
    const userDetailObj = checkUserDetails.success === true ? checkUserDetails.user_detail : {};
    let ownerId = ownerCompanyIdForSave(userDetailObj, currentStateData.new_loop_data.loop_owner_id);
    // api endpoint to fetch store availability
    let storeCapacityApiEndpoint = "campaigns/loop-based/store-capacities/" + numStoreCyreen + "?id_company_owner=" + ownerId + "&date_start=" + dbFormatDate(currentStateData.new_loop_data.loop_start_date) + "&date_end=" + dbFormatDate(currentStateData.new_loop_data.loop_end_date) + "&type=" + currentStateData.new_loop_data.loop_campaign_type;

    if (typeof currentStateData.accepted_loop_files_length !== "undefined") {
        storeCapacityApiEndpoint += "&num_visuals=" + currentStateData.accepted_loop_files_length
    } else {
        storeCapacityApiEndpoint += "&num_visuals=0";
    }

    const storeAvailability = await sendApiRequest(storeCapacityApiEndpoint, {}, "GET");

    if (typeof storeAvailability.success !== "undefined" && storeAvailability.success === true) {
        // save store availability to the redux state
        store.dispatch(
            updateStateData({
                loop_store_availability: storeAvailability.response,
            })
        );
        return {
            success: true,
        }
    } else {
        return {
            success: false,
        }
    }
}

const companyIdsMatch = (firstId, secondId) => {
    if (typeof firstId === "undefined" || firstId === null || firstId === "") {
        return false;
    }
    if (typeof secondId === "undefined" || secondId === null || secondId === "") {
        return false;
    }
    return String(firstId) === String(secondId);
};

// visual-limit is_root=true only when the selected owner is the tenant (hierarchy root)
// or the logged-in user's own company. Other owners keep the current URL.
const shouldRequestVisualLimitAsRoot = (loopOwnerId, currentStateData) => {
    const checkUserDetails = checkUserDetailsFromCookie();
    const assignedCompanyId =
        checkUserDetails.success === true &&
        typeof checkUserDetails.user_detail !== "undefined" &&
        typeof checkUserDetails.user_detail.assigned_company !== "undefined"
            ? checkUserDetails.user_detail.assigned_company.id
            : undefined;

    const tenantCompanyId =
        typeof currentStateData.company_hierarchy !== "undefined" &&
        currentStateData.company_hierarchy !== null &&
        typeof currentStateData.company_hierarchy.root !== "undefined" &&
        currentStateData.company_hierarchy.root !== null
            ? currentStateData.company_hierarchy.root.id
            : undefined;

    return (
        companyIdsMatch(loopOwnerId, tenantCompanyId) === true ||
        companyIdsMatch(loopOwnerId, assignedCompanyId) === true
    );
};

const toLimitNumber = (value) => {
    const parsed = Number(value);
    if (Number.isFinite(parsed) === true) {
        return parsed;
    }
    return 0;
};

// is_root returns one object per retailer. Without is_root it is still a single object.
// Tenant-wide commercial / unlimited / duration are the highest value of each field.
const normalizeVisualLimitPayload = (apiResponse) => {
    if (Array.isArray(apiResponse) === true) {
        let highestCommercial = 0;
        let highestUnlimited = 0;
        let highestDuration = 0;

        apiResponse.forEach((retailer) => {
            const commercialCount = toLimitNumber(retailer?.commercial_limit_count);
            const unlimitedCount = toLimitNumber(retailer?.unlimited_limit_count);
            const maxDuration = toLimitNumber(retailer?.max_duration);

            if (commercialCount > highestCommercial) {
                highestCommercial = commercialCount;
            }
            if (unlimitedCount > highestUnlimited) {
                highestUnlimited = unlimitedCount;
            }
            if (maxDuration > highestDuration) {
                highestDuration = maxDuration;
            }
        });

        return {
            commercial_limit_count: highestCommercial,
            unlimited_limit_count: highestUnlimited,
            max_duration: highestDuration,
            retailers: apiResponse,
        };
    }

    return {
        commercial_limit_count: toLimitNumber(apiResponse?.commercial_limit_count),
        unlimited_limit_count: toLimitNumber(apiResponse?.unlimited_limit_count),
        max_duration: toLimitNumber(apiResponse?.max_duration),
        retailers: [],
    };
};

// loop_prioritization: disabled for pre_prod deploy — inStore not ready
// fetch visual upload limit and max duration for the loop campaign based on owner's limit
export const fetchVisualLimit = async (loopOwnerId, loopCampaignType) => {
    const currentStateData = store.getState().userSelections;
    let visualLimitEndpoint = "visual-limit?id_company_owner=" + loopOwnerId;
    if (shouldRequestVisualLimitAsRoot(loopOwnerId, currentStateData) === true) {
        visualLimitEndpoint += "&is_root=true";
    }

    const visualLimitInfo = await sendApiRequest(visualLimitEndpoint, {}, "GET");
    if (typeof visualLimitInfo.success !== "undefined" && visualLimitInfo.success === true) {
        const visualLimitPayload = normalizeVisualLimitPayload(visualLimitInfo.response);
        const commercialLimitCount = visualLimitPayload.commercial_limit_count;
        const unlimitedLimitCount = visualLimitPayload.unlimited_limit_count;
        const commercialAvailable = commercialLimitCount > 0;
        const unlimitedAvailable = unlimitedLimitCount > 0;

        // Creation: pre-select campaign type only when the owner has access to exactly one type.
        // If both types are available, leave the field empty so the user must choose.
        let visualLimitData = {};
        if (typeof loopCampaignType === "undefined" || loopCampaignType === "") {
            if (commercialAvailable === true && unlimitedAvailable !== true) {
                visualLimitData = {
                    visual_upload_limit: commercialLimitCount,
                    loop_campaign_type_id: "commercial",
                    loop_campaign_type: "Commercial",
                };
            } else if (unlimitedAvailable === true && commercialAvailable !== true) {
                visualLimitData = {
                    visual_upload_limit: unlimitedLimitCount,
                    loop_campaign_type_id: "unlimited",
                    loop_campaign_type: "Unlimited",
                };
            } else {
                visualLimitData = {
                    visual_upload_limit: commercialAvailable === true ? commercialLimitCount : unlimitedLimitCount,
                };
            }
        } else {
            visualLimitData = {
                visual_upload_limit: loopCampaignType === "unlimited" ? unlimitedLimitCount : commercialLimitCount,
            };
        }

        // Re-read state after the API call so concurrent wizard edits are not overwritten.
        const latestStateData = store.getState().userSelections;
        store.dispatch(
            updateStateData({
                new_loop_data: {
                    ...latestStateData.new_loop_data,
                    ...visualLimitData,
                    visual_upload_duration: visualLimitPayload.max_duration,
                },
                loop_campaign_types: {
                    commercial: commercialAvailable,
                    unlimited: unlimitedAvailable,
                    commercial_limit_count: commercialLimitCount,
                    unlimited_limit_count: unlimitedLimitCount,
                },
                // empty when is_root was not sent, so a previous tenant-root owner cannot leak into Visuals
                loop_visual_limit_retailers: visualLimitPayload.retailers,
            })
        );

        return {
            success: true,
        }
    }
    else {
        return {
            success: false,
        }
    }
}
